import "./StudentManagement.scss";
import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import useFullPageLoader from "common/UseFullPageLoader";
import { userDetailApi } from "services/user";
import { LogoImg2, userPlaceholderIcon } from "assets/images";
import { userRoleOptions } from "constants/staticData";
import constant from "../../constants/constatValue";
import { firstWordCapital, getValueOrFallback } from "utils/common";
import { dateFormat, formatToDDMMYYYY } from "utils/dateFormat";
import {
  getEducationLevel,
  getEmployementInfo,
  getIncomeValue,
  getLivingSituationInfo,
  getMaritalStatusValue,
  getMartialStatusValue,
} from "constants/staticDataFunction";
const { USER_ROLE } = constant;

const GroupDetail = () => {
  const { userId } = useParams();
  const [loader, onShow, onHide] = useFullPageLoader();
  const [inputData, setInputData] = useState({});
  const [searchParams, setSearchParams] = useSearchParams({});
  const userRoleValue = searchParams.get("userRole") || "researcher";

  //Handle user role
  const changeUserRoleHandler = (role) => {
    searchParams.set("userRole", role);
    setSearchParams(searchParams);
  };

  // fetch User Deatil
  const fetchSelectedUserDetail = async () => {
    try {
      onShow();
      const { data, status } =
        await userDetailApi(userId);
      if (status === 200) {
        setInputData(data?.data);
      }
    } catch (e) {
      console.log("error:", e.message);
    } finally {
      onHide();
    }
  };

  const getEmail = (role) => {
    switch (role) {
      case "researcher":
        return inputData?.businessEmail;
      case "participant":
        return inputData?.personalEmail;
      default:
        return inputData?.businessEmail || inputData?.personalEmail;
    }
  };

  useEffect(() => {
    fetchSelectedUserDetail(userId);
  }, []);

  return (
    <>
      {loader}
      <div className="editProfile">
        <div className="breadcrumb">
          <ul>
            <li>
              <Link to={-1}>User Management</Link>
            </li>
            <li>User details</li>
          </ul>
        </div>
        <div className="personal_details _box spacing">
          {Array.isArray(inputData?.userRole) &&
            inputData?.userRole.length === 2 && (
              <div className="tab_button_wrap">
                <ul>
                  {USER_ROLE.map((role) => (
                    <li key={role}>
                      <button
                        type="button"
                        className={userRoleValue === role ? "active" : ""}
                        onClick={() => changeUserRoleHandler(role)}
                      >
                        {firstWordCapital(role)}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          <div className="personal_details">
            <div className="image_wrap">
              <img
                src={inputData?.profilePicture || userPlaceholderIcon}
                alt="user profile"
              />
            </div>
            <div className="details_list">
              {/* <ul>
              <li>
                <b>Student No.</b>
                <span>{inputData?.studentNumber}</span>
              </li>
              <li>
                <b>Student Name</b>
                <span>{inputData?.studentNumber}</span>
              </li>
              <li>
                <b>Phone No.</b>
                <div className="has_country_code">
                  <span className="country_code">
                    {inputData.countryCode || "91"}
                  </span>
                </div>
              </li>
              <li>
                <b>Role</b>
                <span>{inputData?.studentNumber}</span>
              </li>
              <li>
                <b>Time Zone</b>
                <span>{inputData.timeZone}</span>
              </li>
              <li>
                <b>Balance</b>
                <span>Rs. 200/-</span>
              </li>
            </ul> */}

              <ul>
                <li>
                  <b>User Name </b>
                  <span>{getValueOrFallback(inputData?.fullName)}</span>
                </li>
                <li>
                  <b>Email </b>
                  <span>
                    {(inputData?.contact?.email || "N/A")}
                  </span>
                </li>
                <li>
                  <b>Phone Number</b>
                  <span>{( inputData?.contact?.mobileNumber?.dialCode || "" ) + " " + (inputData?.contact?.mobileNumber?.number || "")}</span>
                </li>
                <li>
                  <b>Whatsapp Phone Number</b>
                  <span>{( inputData?.contact?.whatsappNumber?.dialCode || "" ) + " " + (inputData?.contact?.whatsappNumber?.number || "")}</span>
                </li>
                <li>
                  <b>DOB </b>
                  <span>{formatToDDMMYYYY(inputData?.dateOfBirth)}</span>
                </li>
                <li>
                  <b>Profession</b>
                  <span>
                    {(inputData?.profession)}
                  </span>
                </li>
                <li>
                  <b>Location</b>
                  <span>
                    {`${inputData?.address?.country}, ${inputData?.address?.state}, ${inputData?.address?.city}`}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default GroupDetail;
